import { TargetingBids } from './campaign-creation.models';

export const DefaultBidLimits: Record<string, { min: number; max: number }> = {
  US: { min: 1, max: 1000000 },
  CA: { min: 1, max: 1000000 },
  UK: { min: 1, max: 1000000 },
  DE: { min: 1, max: 1000000 },
  FR: { min: 1, max: 1000000 },
  IT: { min: 1, max: 1000000 },
  ES: { min: 1, max: 1000000 },
  IN: { min: 50, max: 21000000 },
  JP: { min: 100, max: 21000000 },
  CN: { min: 1, max: 21000000 },
  AU: { min: 1.4, max: 1500000 },
  MX: { min: 1, max: 21000000 },
  UAE: { min: 4, max: 3700000 },
  SA: { min: 4, max: 3700000 },
  BR: { min: 1.32, max: 5300000 },
  NL: { min: 1, max: 1000000 },
  SG: { min: 1.39, max: 1300000 },
  TR: { min: 2, max: 2500000 },
  PL: { min: 2, max: 2000000 },
  SE: { min: 9, max: 9300000 },
  EG: { min: 7, max: 7400000 },
  BE: { min: 1, max: 1000000 },
  ZA: { min: 20, max: 7000000 },
};

export const TargetingBidAPIMapping: Record<TargetingBids, string> = {
  closeMatch: 'QUERYHIGHRELMATCHES',
  looseMatch: 'QUERYBROADRELMATCHES',
  substitutes: 'ASINSUBSTITUTERELATED',
  complements: 'ASINACCESSORYRELATED',
};

export const TargetingBidGroups: TargetingBids[] = ['closeMatch', 'looseMatch', 'substitutes', 'complements'];

export const DefaultBidValueInEUR = 0.3;

export const DefaultMinBidWalmart = 0.2;

export const DefaultMinBudgetWalmart = 10;
